<template>
    <div class="container d-flex justify-content-evenly pb-5" style="padding-top: 100px;">
      <Card class="d-flex flex-column">
        <template #title>
          Preview story
        </template>
        <template #content>
          <div class="d-flex">
            <button class="p-button p-component p-button-info d-inline me-2" style="border-radius: 0.5em;" @click="showCreateModal = true">Add story details</button>
            <button class="p-button p-component p-button-info d-inline me-2" style="border-radius: 0.5em;" @click="showDeleteModal = true">Delete preview story</button>
          </div>
        </template>
      </Card>
      <Card class="d-flex flex-column">
        <template #title>
          1. Upload template
        </template>
        <template #content>
          <div class="d-flex">
            <a href="https://docs.google.com/spreadsheets/d/13GanQsXMAC4Luvv0i0hCHZsRRk4UKp6sG8ZWDTqPK1s/edit?gid=0#gid=0" download="Ornek_Excel.xlsx" target="_blank">
              <button class="p-button p-component p-button-info d-inline me-2" style="border-radius: 0.5em;">Sample Excel</button>
            </a>
            <FileUpload
                mode="basic"
                class="ms-2"
                name="file[]"
                accept=".csv"
                :file-limit="1"
                :customUpload="true"
                @uploader="(event) => uploader(event, 'template')"
                :maxFileSize="5000000"
                choose-label="Upload"
                upload-label="Upload"
                cancel-label="Cancel"
            />
          </div>
        </template>
      </Card>
      <Card class="d-flex flex-column">
        <template #title>
         2. Upload contents
        </template>
        <template #content>
          <div class="d-flex">
            <a href="https://docs.google.com/spreadsheets/d/13GanQsXMAC4Luvv0i0hCHZsRRk4UKp6sG8ZWDTqPK1s/edit?gid=1607396448#gid=1607396448" download="Ornek_Excel.xlsx" target="_blank">
              <button class="p-button p-component p-button-info d-inline me-2"  style="border-radius: 0.5em;">Sample Excel</button>
            </a>
            <FileUpload
                mode="basic"
                class="ms-2"
                name="file[]"
                accept=".csv"
                :file-limit="1"
                :customUpload="true"
                @uploader="(event) => uploader(event, 'contents')"
                :maxFileSize="5000000"
                choose-label="Upload"
                upload-label="Upload"
                cancel-label="Cancel"
            />
          </div>
        </template>
      </Card>
    </div>

  <div>

    <div class="container pb-3">
      <div class="p-input-icon-left d-flex gap-2 align-items-center">
        <InputText v-model="storyKey" @input="updateFilter" placeholder="Story key giriniz..."/>
        <div class="d-flex gap-2" style="color: grey; font-size: 12px">
          <div
              style="width: 1.3rem;height: 1.3rem;padding: 0.2rem 0.2rem;margin-bottom: 0.5rem !important;border-radius: 1.875rem;"
              class="info btn btn-icon-only btn-rounded btn-outline-secondary mb-0 ms-2 btn-sm d-flex align-items-center justify-content-center ms-auto"
          >
            <i class="fas fa-info" aria-hidden="true"></i>
          </div>
          Ekleme yaparken tablodaki "Key" alanı ile filtreleme yapılması gerekiyor. Varsayılan değer: may-preview — ileri tarihlerde farklı bir değer girerek filtrelemelisiniz.
        </div>
      </div>
    </div>
    <AstopiaTable ref="astopiaTable" :columns="columns" :url="'/admin/preview-story/get-all'"
                  :default-post-data="defaultPostData"
                  :axiosDataName="'response'" :sort-field="''" :totalDataName="'totalRecords'" @language-change="languageSelected" @detail-see="detailSee" :optionsList="optionsList" :selectedObj3="true"/>
  </div>

  <CreateModal
      :show="showCreateModal"
      modalTitle="Add story details"
      modalWidth="50%"
      :formFields="[
                { label: 'Cover Title', type: 'text', model: 'coverTitle', required: false },
                { label: 'Story Key', type: 'text', model: 'storyKey', required: false },
                { label: 'Cover Photo Url', type: 'text', model: 'coverPhotoUrl', required: false },
                { label: 'Language', type: 'select', model: 'language', options: supportedLanguages, id: 'id', value: 'name', required: false },
                { label: 'DeepLink Button Text', type: 'text', model: 'deepLinkButtonText', required: false },
              ]"
      @saveEndpoint="createObj"
      method="post"
      @hide="showCreateModal = false"
  />
  <CreateModal
      :show="showDeleteModal"
      modalTitle="Delete preview story"
      modalWidth="50%"
      :formFields="[
                { label: 'Story Key', type: 'text', model: 'storyKey', required: false },
              ]"
      @saveEndpoint="deleteObj"
      method="post"
      @hide="showDeleteModal = false"
  />

  <EditModal
      :show="showEditModal"
      modalTitle="Edit Splash"
      modalWidth="50%"
      :formFields="[
                { label: 'Is Share', type: 'switch', model: 'isShare', required: false},
                { label: 'Is Static', type: 'switch', model: 'isStatic', required: false },
                { label: 'Is Natal Event', type: 'select', model: 'isNatalEvent', required: false},
                { label: 'Order', type: 'text', model: 'order', required: false },
                { label: 'Variant', type: 'text', model: 'variant', required: false},
                { label: 'Sign Id', type: 'text', model: 'signId', required: false },
                { label: 'Sign Id', type: 'select', model: 'signId', options: signs, value: 'id', text: 'name', required: true},
                { label: 'Story Key', type: 'text', model: 'storyKey', required: false},
                { label: 'Title', type: 'text', model: 'title', required: false },
                { label: 'Description', type: 'text', model: 'description', required: false},
                { label: 'Photo Url', type: 'text', model: 'photoUrl', required: false },

              ]"
      :detailEndpoint="`/admin/preview-story/get-by-id/${selectedObjId}?language=${selectedLanguage}`"
      @saveEndpoint="editObj"
      method="put"
      :totalDataName="'response'"
      :isOnlydata="true"
      @hide="showEditModal = false"
  />
</template>

<script>
import Card from "primevue/card";
import {mapGetters} from "vuex";
import AstopiaTable from "@/components/Tables/AstopiaTable.vue";

export default {
  components: {AstopiaTable, Card},
  data(){
    return {
      showCreateModal: false,
      showDeleteModal: false,
      showEditModal: false,
      selectedObjId: null,
      storyKey: 'may-preview',
      data: {
        "coverTitle": "string",
        "storyKey": "string",
        "coverPhotoUrl": "string",
        "language": "string",
        "deepLinkButtonText": "string"
      },
      dataUpdate: {
        "id": 0,
        "isShare": true,
        "isStatic": true,
        "isNatalEvent": true,
        "order": 0,
        "variant": 0,
        "signId": 0,
        "storyKey": "string",
        "description": "string",
        "title": "string",
        "photoUrl": "string"
      },
      columns: [
        {field: "storyKey", header: "Story Key", functionType: "none", selected: true},
        {field: "title", header: "Title", functionType: "none", selected: true},
        {field: "description", header: "Description", functionType: "none", selected: true},
        {field: "photoUrl", header: "Photo Url", functionType: "img", selected: true},
        {field: "isShare", header: "Is Share", functionType: "bool", selected: true},
        {field: "isStatic", header: "Is Static", functionType: "bool", selected: true},
        {field: "isNatalEvent", header: "Is Natal Event", functionType: "bool", selected: true},
        {field: "order", header: "Order", functionType: "none", selected: true},
        {field: "variant", header: "Variant", functionType: "none", selected: true},
        {field: "signId", header: "Sign Id", functionType: "none", edit: true, delete: true, selected: true},
        {field: "Actions", header: "Actions", functionType: "crud", edit: true, delete: false, selected: true},
      ],
      optionsList: [],
      selectedLanguage: "en"
    }
  },
  methods:{
    languageSelected(obj){
      this.selectedLanguage = obj
    },
    uploader(event, type) {
      const file = event.files[0];
      let formData = new FormData();
      formData.append("file", file);

      let endpoint = '';
      switch (type) {
        case 'template':
          endpoint = "admin/preview-story/upload-template";
          break;
        case 'contents':
          endpoint = "admin/preview-story/upload-contents";
          break;
        default:
          return;
      }
      this.$appAxios
          .post(endpoint, formData)
          .then(() => {
            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: `${type.charAt(0).toUpperCase() + type.slice(1)} file was uploaded successfully`,
              life: 3000
            });
            this.$swal.fire({
              text: "Dosya başarıyla yüklendi ve veriler eklendi.",
              icon: "success",
              customClass: {
                container: "my-sweet",
              },
              confirmButtonText: this.$t("global.ok"),
            });
          })
          .catch(() => {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: `Could not upload the ${type} file`,
              life: 3000
            });
          });
    },
    detailSee(obj){
      this.selectedObjId = obj.id
      this.showEditModal = true
    },
    editObj(obj) {
      this.dataUpdate.isShare = obj.isShare;
      this.dataUpdate.isStatic = obj.isStatic;
      this.dataUpdate.isNatalEvent = obj.isNatalEvent
      this.dataUpdate.order = obj.order;
      this.dataUpdate.variant = obj.variant;
      this.dataUpdate.signId = obj.signId;
      this.dataUpdate.storyKey = obj.storyKey
      this.dataUpdate.description = obj.description;
      this.dataUpdate.title = obj.title;
      this.dataUpdate.photoUrl = obj.photoUrl;
      this.$appAxios.put(`/admin/preview-story/update/${obj.id}`, this.dataUpdate).then(() => {
        this.refreshTable()
        this.showEditModal = false
      }).catch(() => {
        this.showEditModal = false
      })
    },
    createObj(obj) {
      this.data.coverTitle = obj.coverTitle;
      this.data.storyKey = obj.storyKey;
      this.data.coverPhotoUrl = obj.coverPhotoUrl;
      this.data.language = obj.language;
      this.data.deepLinkButtonText = obj.deepLinkButtonText;
      this.$appAxios.post("/admin/preview-story/add-story-details", this.data).then(() => {
        this.showCreateModal = false
      }).catch(() => {
        this.showCreateModal = false
      })
    },
    deleteObj(obj){
      this.$appAxios.post(`/admin/preview-story/delete-preview-story?storyKey=${obj.storyKey}`).then(() => {
        this.showDeleteModal = false
      }).catch(() => {
        this.showDeleteModal = false
      })
    },
    updateFilter() {
      if (this.$refs.astopiaTable?.getData) {
        this.$refs.astopiaTable.getData();
      }
    },
  },
  computed: {
    defaultPostData() {
      return `?storyKey=${this.storyKey}&test=test`;
    },
    ...mapGetters(['supportedLanguages','signs']),
  }
}
</script>